// src/pages/Admin/VotePage/ui/VoteTypePill.jsx

import React from "react";
import { FaChartBar, FaVoteYea } from "react-icons/fa";

export default function VoteTypePill({
  type,
  isAnonymous,
}) {
  const isSurvey = type === "sondage";
  const Icon = isSurvey ? FaChartBar : FaVoteYea;

  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-black text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
      <Icon />

      {isSurvey ? "Sondage" : "Vote"}

      <span className="font-medium opacity-70">
        · {isAnonymous === false ? "nominatif" : "anonyme"}
      </span>
    </span>
  );
}